// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GdpS-","clinicsSelect":"styles_clinicsSelect__3-YWr"};